// hooks/useOnlineStatus.js
// Is the browser online? Follows the online/offline events (navigator.onLine is
// coarse — it can't see a dead Wi-Fi uplink — but it catches the common case of
// a terminal or phone dropping its connection).
import { useEffect, useState } from "react";

export default function useOnlineStatus() {
    const [online, setOnline] = useState(() => (typeof navigator === "undefined" ? true : navigator.onLine !== false));
    useEffect(() => {
        const up = () => setOnline(true);
        const down = () => setOnline(false);
        window.addEventListener("online", up);
        window.addEventListener("offline", down);
        return () => {
            window.removeEventListener("online", up);
            window.removeEventListener("offline", down);
        };
    }, []);
    return online;
}
